"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientReduxProvider = void 0;
const React = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
class ClientReduxProvider extends BaseProvider_1.BaseProvider {
    constructor(appReducer, middlewares, withDevTools = true) {
        let preloadedState = window.__PRELOADED_STATE__ || {};
        delete window.__PRELOADED_STATE__;
        super((0, redux_1.legacy_createStore)(appReducer, preloadedState, ((withDevTools && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
            redux_1.compose)((0, redux_1.applyMiddleware)(...middlewares))));
    }
    component(children) {
        return React.createElement(react_redux_1.Provider, { store: this.provider }, children);
    }
}
exports.ClientReduxProvider = ClientReduxProvider;
//# sourceMappingURL=ClientReduxProvider.js.map